import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { RootState } from 'types';

import UserFeedbackModal from './UserFeedbackModal';
import { FeedbackLauncherButton } from './style';
import { captureCurrentPageSnapshot } from '../screenCapture';
import { UserFeedbackScreenCapture } from '../types';
import { buildFeedbackPageContext, isFeedbackSupportedPath, mapSessionUserToFeedbackActor } from '../utils';

export default function UserFeedbackLauncher() {
  const location = useLocation();
  const { loggedIn, user } = useSelector((state: RootState) => state.session);
  const [isOpen, setIsOpen] = React.useState(false);
  const [screenCapture, setScreenCapture] =
    React.useState<UserFeedbackScreenCapture | null>(null);

  if (!loggedIn || !isFeedbackSupportedPath(location.pathname)) return null;

  const pageContext = buildFeedbackPageContext(
    location.pathname,
    location.search,
  );
  const reporter = mapSessionUserToFeedbackActor(user);

  const handleOpen = async () => {
    setScreenCapture(null);
    try {
      setScreenCapture(await captureCurrentPageSnapshot());
    } catch {
      setScreenCapture(null);
    } finally {
      setIsOpen(true);
    }
  };

  return (
    <>
      <FeedbackLauncherButton
        aria-label="Submit feedback or report an issue"
        data-feedback-launcher="true"
        onClick={handleOpen}
        title="Submit feedback or report an issue"
        type="button"
      >
        <FiMessageSquare />
      </FeedbackLauncherButton>

      <UserFeedbackModal
        onHide={() => setIsOpen(false)}
        pageContext={pageContext}
        reporter={reporter}
        screenCapture={screenCapture}
        show={isOpen}
      />
    </>
  );
}
